import { useCallback } from "react";
import { useMessageToState } from "../../../../hooks/useMessageToState";

export const useSelectedSymbol = (selectedZone: eXpress.core.IZone | undefined) => {
	return useMessageToState({
		name: "useSelectedSymbol",
		filterMessage: (message) =>
			eXpress.core.isSelectedZoneChanged(message) ||
			eXpress.core.isZoneAffected(message, selectedZone),
		getState: useCallback(
			() => (eXpress.core.isSymbolZone(selectedZone) ? selectedZone.symbol : undefined),
			[selectedZone],
		),
	});
};
